export default __webpack_public_path__ + "static/media/infernocurse.0f3b50f2.png";